import { Link, useNavigate } from '@tanstack/react-location'
import ScreenLayout from 'MediaManager/layouts/ScreenLayout'
import { getLivingVariants } from 'MediaManager/services/variants'
import React, { useCallback } from 'react'
import DataTable from 'shared/components/DataTable'
import Loader from 'shared/components/Loader'
import { useRequest } from 'shared/hooks/useRequest'

function ManageLivingVariantsScreen(props) {
  const getLivingVariantTypesRequest = useCallback(async () => {
    const { data } = await getLivingVariants()
    return data.living_variants
  }, [])

  const { data: variants, loading } = useRequest(getLivingVariantTypesRequest)

  const table = [
    {
      label: 'ID',
      data: (d) => d.id,
    },
    {
      label: 'Name',
      data: (d) => (
        <Link className="underline" to={`/living/variants/edit?id=${d.id}`}>
          {d.configuration.name || '-'}
        </Link>
      ),
    },
    {
      label: 'Type',
      data: (d) => d.living_variant_type.type || '-',
    },
  ]

  const actions = [
    {
      label: 'Add variant',
      action: () => {
        navigate({ to: `/living/variants/create` })
      },
    },
  ]

  const navigate = useNavigate()

  return (
    <ScreenLayout title="Manage variants">
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      {!loading && (
        <DataTable
          actions={actions}
          onRowClick={(row) => navigate({ to: `/living/variants/edit?id=${row.id}` })}
          data={variants}
          title="Manage living variants"
          structure={table}
        />
      )}
    </ScreenLayout>
  )
}

export default ManageLivingVariantsScreen
